module.exports = __webpack_public_path__ + "images/oth-cards.jpg";